<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      copyright © {{ new Date().getFullYear() }} {{ appName }}
      <span
        class="d-none d-sm-inline-block"
      >, Todos os direitos reservados</span>
    </span>

    <span
      class="float-md-right d-none d-md-block"
    >Hand-crafted &amp; made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
    <b-modal
      v-model="showModalUpdate"
      centered
      title="Nova Versão"
      ok-title="Atualizar"
      cancel-title="Voltar"
      @ok="refreshApp"
    >
      Chegou uma nova atualização do app, confira!
    </b-modal>
  </p>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

const { appName } = $themeConfig.app

export default {
  components: {
    BModal,
  },
  data() {
    return {
      refreshing: false,
      showModalUpdate: false,
      appName,
      registration: null,
    }
  },
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },
  methods: {
    showRefreshUI(e) {
      this.registration = e.detail
      this.showModalUpdate = true
    },
    refreshApp() {
      this.showModalUpdate = false
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage('skipWaiting')
    },
  },
}
</script>
